module.exports = __webpack_public_path__ + "static/media/tvshows.72b167ef.svg";